"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydratePackages = exports.removeLiveDataFromPackages = void 0;
const fluture_1 = require("fluture");
const monet_1 = require("monet");
const config_1 = require("../config");
const commercetools_1 = require("./commercetools");
/**
 * The initial store should not contain any discounts or out of stock information since these are loaded in real time.
 *
 *  @private not for use outside of ecomm-data
 */
const removeLiveDataFromPackages = (enable) => (packages) => {
    return enable
        ? packages.map((v) => ({
            ...v,
            absoluteDiscount: (0, monet_1.None)(),
            absoluteDiscountWithServicePlan: (0, monet_1.None)(),
            discountedPrice: (0, monet_1.None)(),
            discountedPriceWithServicePlan: (0, monet_1.None)(),
            relativeDiscount: (0, monet_1.None)(),
            relativeDiscountWithServicePlan: (0, monet_1.None)()
        }))
        : packages;
};
exports.removeLiveDataFromPackages = removeLiveDataFromPackages;
const hydratePackages = (removeLiveData = true) => (0, commercetools_1.commercetoolsRequestPackages)(config_1.locale)
    .pipe((0, fluture_1.map)(commercetools_1.formatPackageResponse))
    .pipe((0, fluture_1.chain)(_packages => _packages.cata(fluture_1.reject, fluture_1.resolve)))
    .pipe((0, fluture_1.map)((0, exports.removeLiveDataFromPackages)(removeLiveData)));
exports.hydratePackages = hydratePackages;
//# sourceMappingURL=hydrate.js.map